import type { CanMatchFn } from '@angular/router';

import { inject } from '@angular/core';
import { filter, map, type Observable, of, take } from 'rxjs';

import { AuthService } from '#core/components/auth/auth.service';
import { ExperimentationService } from '#core/services/experimentation.service';
import { SessionStore } from '#core/store/session.store';

// Never redirects: a false answer must let the router fall through to the v1 menu route declared on the same path.
export const menuV2FeatureGuard: CanMatchFn = (): Observable<boolean> => {
    // Without a session the features never load, and the v1 route lets the AuthGuard redirect to the login page.
    if (!inject(AuthService).isAuthenticated()) {
        return of(false);
    }

    // canMatch runs before the logged-in layout guards, so on a full page load nothing has created the SessionStore yet.
    // Creating it starts the user load, which is what loads the features this guard waits for.
    inject(SessionStore);

    const experimentationService = inject(ExperimentationService);

    return experimentationService.isLoaded$.pipe(
        filter(Boolean),
        take(1),
        map(() => experimentationService.isFeatureEnabled('release-restaurant-menus-v2'))
    );
};
